var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import _ from 'lodash';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Helmet } from 'react-helmet/es/Helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { API_CREATE_COLUMN_FAVORITE, API_DELETE_COLUMN_FAVORITE, API_GET_ONE_COLUMN, apiCreateColumnFavorite, apiDeleteColumnFavorite, apiGetOneColumn, } from '@/actions/ColumnActions';
import { API_CREATE_PROFESSIONAL_FAVORITE, API_DELETE_PROFESSIONAL_FAVORITE, apiCreateProfessionalFavorite, apiDeleteProfessionalFavorite, } from '@/actions/FavoriteActions';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { SideMenuBanner } from '@/components/modules/Layout/SideMenu/SideMenuBanner';
import { SideMenuPopular } from '@/components/modules/Layout/SideMenu/SideMenuPopular/SideMenuPopular';
import { SEMINAR_BANNER_IMAGE_URL, SEMINAR_BANNER_SIDE_PC_IMAGE_URL, } from '@/define/consts/assets';
import { notify } from '@/helpers/action';
import { propMatch } from '@/helpers/custom-prop-types';
import { isLoading, isLoadingIfUndefined } from '@/helpers/fetch';
import { removeLineBreaksFromString } from '@/helpers/string';
import { useRegistrationCta } from '@/helpers/use/useRegistrationCta';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { usePopularList } from '@/hooks/pages/list/popular/usePopularList';
import { usePopularListColumnViewData, usePopularListProfessionalViewData, } from '@/hooks/pages/list/popular/usePopularListViewData';
import { useBoolState } from '@/hooks/state/useBoolState';
import { wrapDispatch } from '@/utils/actions/dispatch';
import compose from '@/utils/compose/compose';
import { isClient, isGuest, isProfessional, } from '@/utils/resources/auth/authResource';
import { isClientPreStatus } from '@/utils/resources/profile/profileResource';
import { REGISTRATION_TYPE_COLUMN } from '@/utils/resources/registration/registrationType';
import { columnListPath, myPagePath, seminarListPath, } from '@/utils/router/links';
import useAnalytics from '../../../helpers/use/analytics/useAnalytics';
import GoogleAnalytics from '../../../vendor/GoogleAnalytics';
import Layout from '../../Layout';
import Breadcrumb from '../../Layout/Breadcrumb';
import ExaminationAlertAndHeadCardFullModal from '../../Ui/Modal/ExaminationAlertAndHeadCardFullModal';
import RegistrationAlertModal from '../../Ui/Modal/RegistrationAlertModal';
import RegistrationCompleteModal from '../../Ui/Modal/RegistrationCompleteModal';
import RegistrationCta from '../../Ui/Registration/RegistrationCta';
import CategoryHoc from '../../Ui/System/CategoryHoc';
import LoginAlertModal from '../Common/LoginAlertModal';
import ColumnComponent from './ColumnComponent';
import FooterFollow from './FooterFollow';
const ColumnOne = (props) => {
    const { match: { params: { url_code: urlCode }, }, } = props;
    // reducer処理
    const dispatch = useDispatch();
    const { auth, column, favoriteLoading, followLoading, loading, profile } = useSelector((state) => {
        const stateColumn = state.column.one[urlCode];
        const professionalId = stateColumn && stateColumn.professional && stateColumn.professional.id;
        return {
            auth: state.auth,
            column: stateColumn,
            favoriteLoading: isLoadingIfUndefined(state, API_CREATE_COLUMN_FAVORITE, urlCode, false) ||
                isLoadingIfUndefined(state, API_DELETE_COLUMN_FAVORITE, urlCode, false),
            followLoading: isLoadingIfUndefined(state, API_CREATE_PROFESSIONAL_FAVORITE, professionalId, false) ||
                isLoadingIfUndefined(state, API_DELETE_PROFESSIONAL_FAVORITE, professionalId, false),
            loading: isLoading(state, API_GET_ONE_COLUMN, urlCode),
            professionalId,
            profile: state.profile,
        };
    });
    // サイドメニュー用キーワード
    const columnThemeKeyword = useMemo(() => _.get(column, 'themes.0.name'), [column]);
    // ユーザー情報
    const member = useMemo(() => ({
        isClientUser: isClient(auth),
        isGuestUser: isGuest(auth),
        isPreUser: isClientPreStatus(profile),
        isProUser: isProfessional(auth),
    }), [auth, profile]);
    const loadingRef = useRef(false);
    const unmountRef = useUnmountRef();
    loadingRef.current = loading;
    // ナビゲーション
    const pans = useMemo(() => {
        const memoPans = [
            {
                link: columnListPath(),
                text: 'コラム',
            },
        ];
        if (column) {
            memoPans.push({ link: '', text: column.title });
        }
        if (!member.isGuestUser) {
            memoPans.unshift({
                link: myPagePath(),
                text: 'マイページ',
            });
        }
        return memoPans;
    }, [member.isGuestUser, column]);
    // データ取得
    useEffect(() => {
        if (loadingRef.current === true) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiGetOneColumn(urlCode));
        }))();
    }, [urlCode, member.isClientUser, dispatch]);
    // コラムお気に入り取得状態
    const [favorites, changeFavorites] = useState({});
    const favoriteUrlCode = favorites[urlCode];
    const hasFavorite = useMemo(() => {
        if (favoriteUrlCode === undefined) {
            return !!(column && column.hasFavorite);
        }
        return !!favoriteUrlCode;
    }, [column, favoriteUrlCode]);
    // コンサルお気に入り取得状態
    const [follows, changeFollows] = useState({});
    const columnProfessionalId = column && column.professional && column.professional.id;
    const columnProfessionalFavorite = !!(column &&
        column.professional &&
        column.professional.hasFavorite);
    const followById = follows[columnProfessionalId];
    const hasFollow = useMemo(() => {
        if (followById === undefined) {
            return columnProfessionalFavorite;
        }
        return !!followById;
    }, [columnProfessionalFavorite, followById]);
    // ログインモーダル
    const { boolState: showLoginModal, changeFalse: hideLoginAlert, changeTrue: showLoginAlert, } = useBoolState({ initialState: false });
    // 仮登録モーダル
    const { boolState: showPreAlertModal, changeFalse: hidePreAlert, changeTrue: showPreAlert, } = useBoolState({ initialState: false });
    // お気に入りボタン操作
    const onCreateFavorite = useCallback((e) => {
        if (member.isGuestUser) {
            showLoginAlert();
            return;
        }
        if (member.isPreUser) {
            showPreAlert();
            return;
        }
        const { value } = e.currentTarget;
        changeFavorites((prevState) => (Object.assign(Object.assign({}, prevState), { [value]: true })));
        wrapDispatch(dispatch, apiCreateColumnFavorite(value)).then(() => {
            notify(_jsxs(_Fragment, { children: [_jsx("span", { children: "\u30DE\u30A4\u30DA\u30FC\u30B8\u306B\u4FDD\u5B58\u3057\u307E\u3057\u305F" }), _jsx(Link, Object.assign({ to: '/mypage/favorites' }, { children: "\u30DA\u30FC\u30B8\u306B\u79FB\u52D5" }))] }));
        });
    }, [
        dispatch,
        showLoginAlert,
        showPreAlert,
        member.isGuestUser,
        member.isPreUser,
    ]);
    const onDeleteFavorite = useCallback((e) => {
        if (member.isGuestUser) {
            showLoginAlert();
            return;
        }
        if (member.isPreUser) {
            showPreAlert();
            return;
        }
        const { value } = e.currentTarget;
        changeFavorites((prevState) => (Object.assign(Object.assign({}, prevState), { [value]: false })));
        dispatch(apiDeleteColumnFavorite(value));
    }, [
        dispatch,
        showLoginAlert,
        showPreAlert,
        member.isGuestUser,
        member.isPreUser,
    ]);
    // フォローボタン操作
    const onCreateFollow = useCallback((e) => {
        if (member.isGuestUser) {
            showLoginAlert();
            return;
        }
        if (member.isPreUser) {
            showPreAlert();
            return;
        }
        const { value } = e.currentTarget;
        changeFollows((prevState) => (Object.assign(Object.assign({}, prevState), { [value]: true })));
        wrapDispatch(dispatch, apiCreateProfessionalFavorite(value)).then(() => {
            notify(_jsxs(_Fragment, { children: [_jsx("span", { children: "\u30DE\u30A4\u30DA\u30FC\u30B8\u306B\u4FDD\u5B58\u3057\u307E\u3057\u305F" }), _jsx(Link, Object.assign({ to: '/mypage/favorites' }, { children: "\u30DA\u30FC\u30B8\u306B\u79FB\u52D5" }))] }));
        });
    }, [
        dispatch,
        showLoginAlert,
        showPreAlert,
        member.isGuestUser,
        member.isPreUser,
    ]);
    const onDeleteFollow = useCallback((e) => {
        if (member.isGuestUser) {
            showLoginAlert();
            return;
        }
        if (member.isPreUser) {
            showPreAlert();
            return;
        }
        const { value } = e.currentTarget;
        changeFollows((prevState) => (Object.assign(Object.assign({}, prevState), { [value]: false })));
        dispatch(apiDeleteProfessionalFavorite(value));
    }, [
        dispatch,
        showLoginAlert,
        showPreAlert,
        member.isGuestUser,
        member.isPreUser,
    ]);
    const { onClickHtmlLabel, onClickRegistration } = useAnalytics.useColumn();
    const { hideModal, isShowForm, isShowModal, onSubmitAfter, scrollToForm } = useRegistrationCta.useRegistrationCtaForm('column_registration_form', member.isGuestUser, onClickRegistration);
    // 登録モーダル
    const { boolState: showRegistrationModal, changeFalse: hideRegistrationAlert, changeTrue: showRegistrationAlert, } = useBoolState({
        callbackChangeTrue: onClickRegistration,
        initialState: false,
    });
    const tagTitle = column && column.title ? column.title : 'コラム';
    const metaDescription = useMemo(() => (column ? removeLineBreaksFromString(column.metaDescription) : ''), [column]);
    const { isLoadingPopularCase, isLoadingPopularColumn, isLoadingPopularProfessional, popularCases, popularConsultantListHasMoreLink, popularProfessionals, populars, } = usePopularList({
        dispatch,
        isGuestUser: member.isGuestUser,
        isProfessionalUser: member.isProUser,
        keyword: columnThemeKeyword,
        unmountRef,
    });
    // 週間ランキング
    const weeklyRankingList = usePopularListColumnViewData({ populars });
    // 人気のコンサルタント
    const popularConsultantList = usePopularListProfessionalViewData({
        items: popularProfessionals,
    });
    if (loadingRef.current === false && !column) {
        return _jsx(CustomRedirect, { to: '/column' });
    }
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main column_one_container column_common_container no-need-bottom-space' }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: `${tagTitle}｜PROFFIT` }), metaDescription && (_jsx("meta", { content: metaDescription, name: 'description' }))] }), _jsx(Breadcrumb, { lists: pans }), _jsxs("div", Object.assign({ className: clsx('column_container', 'gap-80 lg:gap-48') }, { children: [_jsx("div", Object.assign({ className: 'column_container_main' }, { children: _jsx(ColumnComponent, { auth: auth, column: column, hasFavorite: hasFavorite, hasFollow: hasFollow, id: profile === null || profile === void 0 ? void 0 : profile.id, isGuestUser: member.isGuestUser, isPreUser: member.isPreUser, isProUser: member.isProUser, loadingFavorite: favoriteLoading, loadingFollow: followLoading, onClickButton: onClickHtmlLabel, onClickLimitRegistration: scrollToForm, onCreateFavorite: onCreateFavorite, onCreateFollow: onCreateFollow, onDeleteFavorite: onDeleteFavorite, onDeleteFollow: onDeleteFollow }) })), _jsx(SideMenuPopular, { bannerComponent: _jsx(SideMenuBanner, { gtmSettings: {
                                'data-gtm_category': 'banner',
                                'data-gtm_label': 'column_banner_click',
                                'data-gtm_value': '',
                            }, linkClickEvent: GoogleAnalytics.sendClickEventFromDataAtr, linkTo: seminarListPath(), pcImageSrc: SEMINAR_BANNER_SIDE_PC_IMAGE_URL, spImageSrc: SEMINAR_BANNER_IMAGE_URL }), className: clsx('flex-shrink-0', 'w-full lg:w-[270px]'), isGuestUser: member.isGuestUser, isLoadingPopularCase: isLoadingPopularCase, isLoadingPopularConsultant: isLoadingPopularProfessional, isLoadingWeeklyRankingList: isLoadingPopularColumn, isProfessionalUser: member.isProUser, onClickRegistration: showRegistrationAlert, popularCases: popularCases, popularConsultantList: popularConsultantList, popularConsultantListHasMoreLink: popularConsultantListHasMoreLink, weeklyRankingList: weeklyRankingList, weeklyRankingListLimit: 7, weeklyRankingMoreLink: columnListPath() })] })), column && _jsx(FooterFollow, { urlCode: urlCode }), _jsx(RegistrationCta, { isShow: isShowForm, onSubmitAfter: onSubmitAfter, registrationType: REGISTRATION_TYPE_COLUMN, scrollName: 'column_registration_form' }), _jsx(RegistrationCompleteModal, { hideModal: hideModal, isShow: isShowModal, timeout: 300 }), _jsx(LoginAlertModal, { isShow: showLoginModal, onClickClose: hideLoginAlert }), _jsx(RegistrationAlertModal, { isShow: showRegistrationModal, onClickOther: hideRegistrationAlert, registrationType: REGISTRATION_TYPE_COLUMN }), _jsx(ExaminationAlertAndHeadCardFullModal, { isShow: showPreAlertModal, onClickClose: hidePreAlert })] })));
};
ColumnOne.propTypes = {
    match: propMatch(),
};
const enhance = compose(CategoryHoc('column_theme', 'columnThemes'));
export default enhance(ColumnOne);
